import { render, staticRenderFns } from "./WidgetFullCalendar.vue?vue&type=template&id=590438c2&scoped=true&"
import script from "./WidgetFullCalendar.vue?vue&type=script&lang=js&"
export * from "./WidgetFullCalendar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "590438c2",
  null
  
)

export default component.exports